export default "__VITE_ASSET__Od5dyxTr__"